module.exports = "/images/ScottC 1.png?ae7c6ee1d97c7551b4644a8868777a67";